import { pageTitles } from "../constants/pageTitles";

export const langContent = {
  Russian: {
    nav: {
      Russian: "Русский",
      Polish: "Polski",
      home: pageTitles.Russian.home,
      services: pageTitles.Russian.services,
      servicesResidence: "Вид на жительство",
      servicesCitizenship: "Гражданство",
      servicesTranscription: "Транскрипция документов ЗАГС",
      servicesOther: "Иные услуги",
      knowledge: pageTitles.Russian.faq,
      knowledgeLinks: "Полезные ссылки",
      knowledgeFaqGeneral: "FAQ: Общие вопросы",
      knowledgeFaqResidence: "FAQ: Вид на жительство",
      knowledgeFaqCitizenship: "FAQ: Гражданство",
      knowledgeFaqTranscription: "FAQ: Транскрипция документов ЗАГС",
      contact: pageTitles.Russian.contact,
      menu: "меню",
      privacyPolicy: "Политика конфиденциальности",
    },

    index: {
      // hero
      heroTitle: "КОМПЛЕКСНАЯ ПОМОЩЬ ИНОСТРАНЦУ В ПОЛЬШЕ",
      heroSubtitleLine1:
        "Помогаем иностранцам легально жить и работать в Польше",
      heroSubtitleLine2:
        "Берём на себя все формальности и сопровождаем до получения решения",

      // offer — три блока услуг
      offerDocsHeader: "ОФОРМЛЕНИЕ БАЗОВЫХ ДОКУМЕНТОВ ДЛЯ ЖИЗНИ В ПОЛЬШЕ",
      offerDocsText:
        "Помогаем оперативно решить первые формальности для комфортного старта и интеграции: от регистрации PESEL и открытия банковского счёта до создания электронной подписи (Profil Zaufany) и настройки официального цифрового ящика e-Doręczenia.",
      offerDocsLink: "Подробнее о документах →",

      offerLegalizationHeader: "ЛЕГАЛИЗАЦИЯ ПРЕБЫВАНИЯ",
      offerLegalizationText:
        "Помогаем подготовить и подать документы на временный вид на жительство (включая Blue Card), постоянный вид на жительство, вид на жительство долгосрочного резидента ЕС и польское гражданство. Полное экспертное сопровождение до получения результата.",
      offerLegalizationLink1: "Подробнее о карте побыту →",
      offerLegalizationLink2: "Подробнее о гражданстве →",

      offerSupportHeader: "ПОДДЕРЖКА И СОПРОВОЖДЕНИЕ",
      offerSupportText:
        "Помогаем разобраться в сложных ситуациях и во всех нюансах жизни в Польше: легальность трудоустройства, смена работодателя, подготовка писем и обращений, замена прав, языковые курсы и экзамены, присяжные переводы и апостиль. Защищаем ваши интересы в нестандартных ситуациях.",
      offerSupportLink: "Подробнее об иных услугах →",

      // consultation — призыв записаться на консультацию
      consultationTitle: "Начните с консультации",
      consultationSubtitle:
        "Выберите удобные для вас дату, время и формат (онлайн или офлайн)",
      consultationList: [
        "Вы сами выбираете время",
        "Подтверждение сразу после записи",
        "Напоминание перед консультацией",
      ],
      consultationNote:
        "Ответим на ваши вопросы и подскажем оптимальное решение",
      consultationButton: "Выбрать время",

      // shared form feedback (используется на странице контактов)
      formSuccessTitle: "Отправлено!",
      formSuccessText: "Мы скоро свяжемся с вами!",
      formErrorTitle: "Ошибка!",
      formErrorText: "Что-то пошло не так",
      formErrorButton: "Закрыть",
      formConsentData:
        "Я даю согласие на обработку компанией AgwiPol моих персональных данных для контакта со мной на указанный мной электронный адрес или на указанный мной номер телефона.*",
      formConsentDoc:
        "Я заявляю, что ознакомился(-ась) с информацией об обработке персональных и понимаю её содержание.*",
      formConsentLink:
        "С информацией об обработке персональных данных можно ознакомиться ",
      formConsentLinkText: "здесь",

      // callback form (used by the FAQ page)
      formTitle: "Свяжитесь с нами",
      formIntroTitle: "Остались вопросы? Оставьте контакт, мы свяжемся с вами",
      formBenefits: [
        "Перезвоним в рабочее время",
        "Ответим на ваши вопросы",
        "Разберём вашу ситуацию и подскажем возможные решения",
      ],
      formName: "Имя:",
      formNameErrorLength1: "Пожалуйста, введите имя",
      formNameErrorLength2: "Ваше имя не может быть короче 2 символов",
      formNameErrorLetters: "Ваше имя должно состоять только из букв",
      formNamePlaceholder: "Введите имя",
      formNumber: "Контактный номер Viber/Telegram/WhatsApp:",
      formNumberErrorLength1: "Пожалуйста, введите номер телефона",
      formNumberErrorLength2: "Ваш номер телефона не может быть короче 7 цифр",
      formNumberErrorFormat:
        "Пожалуйста, введите номер с кодом страны (например, +375)",
      formNumberPlaceholder: "Введите номер телефона",
      formButton: "Перезвоните мне",

      // principles
      principlesStats: [
        {
          value: "9+",
          label:
            "лет опыта в сфере легализации и оформления документов в Польше",
        },
        { value: "5000+", label: "успешных кейсов и довольных клиентов" },
        {
          value: "95%",
          label: "клиентов обращаются к нам повторно и рекомендуют друзьям",
        },
      ],
      principlesTitle:
        "Наша задача - сделать процесс оформления документов в Польше максимально понятным, спокойным и предсказуемым для вас.",
      principlesIntroLead:
        "Наш подход к работе сформировался на основе собственного опыта переезда и жизни в Польше.",
      principlesChallengesIntro:
        "На практике мы столкнулись с тем, насколько сложными и запутанными могут быть:",
      principlesChallenges: [
        "легализация пребывания",
        "оформление документов",
        "взаимодействие с государственными органами в Польше",
      ],
      principlesChallengesOutro:
        "Множество вопросов, противоречивая информация и отсутствие понятного алгоритма действий усложняют процесс и увеличивают риск ошибок.",
      principlesGoalsIntro:
        "Именно поэтому мы выстроили работу так, чтобы наши клиенты понимали:",
      principlesGoals: [
        "какие документы необходимы",
        "какие шаги нужно предпринять",
        "как разобраться, всё ли оформлено правильно",
        "на что стоит обратить внимание на каждом этапе",
      ],
      principlesExperience1:
        "С 2017 года сопровождаем иностранцев в вопросах легализации и оформления документов в Польше.",
      principlesExperience2:
        "Работаем как с базовыми запросами, так и со сложными случаями, включая отказы и нестандартные ситуации.",
      principlesTitle2: "Наши принципы",
      principlesFirstHeader: "Прозрачность и ответственность",
      principlesFirstParagraph:
        "Работаем официально. Все условия сотрудничества фиксируются в договоре. Заранее объясняем порядок действий, возможные варианты и реальные перспективы по делу. Следим за соответствием документов действующим требованиям законодательства.",
      principlesSecondHeader: "Индивидуальный подход и конфиденциальность",
      principlesSecondParagraph:
        "Каждая ситуация рассматривается отдельно. Берём в работу только те случаи, где можем быть действительно полезны. Соблюдаем принципы конфиденциальности и защиты персональных данных.",
      principlesThirdHeader: "Сопровождение до результата",
      principlesThirdParagraph:
        "Остаёмся на связи и сопровождаем клиента на каждом этапе – от подготовки документов до получения решения.",

      // trust — секция с отзывами (виджет Google добавим позже)
      trustTitle: "Нам доверяют",
    },

    services: {
      // Shown in the page Header banner (see Header.tsx).
      header: "УСЛУГИ",

      // ============ SECTION 1: KARTA POBYTU (вид на жительство) ============
      residence: {
        title: "ПОМОЩЬ В ПОЛУЧЕНИИ ВИДА НА ЖИТЕЛЬСТВО В ПОЛЬШЕ (KARTA POBYTU)",
        intro:
          "Помогаем подготовить и подать документы, а также сопровождаем на любом этапе легализации, по любым основаниям (работа, бизнес, воссоединение семьи, карта поляка и др.) до получения:",
        cards: [
          "Karta czasowego pobytu (временный вид на жительство), включая BLUE CARD для высококвалифицированных специалистов.",
          "Karta stałego pobytu (постоянный вид на жительство).",
          "Karta rezydenta długoterminowego UE (карта долгосрочного резидента ЕС).",
        ],
        disclaimer: [
          "Мы не даем пустых обещаний и стопроцентных гарантий успеха, так как окончательное решение всегда остаётся за государственными органами. Наша задача – минимизировать риск критических ошибок при подаче документов и помочь вам достичь поставленной цели законным и безопасным способом.",
          "Мы выстроили работу таким образом, чтобы процесс был максимально понятным и предсказуемым для клиента. Сотрудничество состоит из двух основных этапов:",
        ],

        step1: {
          title: "ШАГ 1. РАЗБОР СИТУАЦИИ И АУДИТ ОСНОВАНИЙ",
          text: "Каждое дело уникально. Мы подробно анализируем вашу ситуацию, проверяем имеющиеся документы на соответствие актуальным требованиям законодательства и подбираем наиболее надежный путь легализации. Берём в работу только те случаи, где объективно можем быть действительно полезны.",
          options: [
            "Первичная экспресс-консультация (до 15 минут) — бесплатно.",
            "Полноценная консультация (до 1 часа) — 200 zł.",
          ],
          important: [
            "ВАЖНО: В случае дальнейшего сотрудничества в рамках Базового или Расширенного пакета услуг, стоимость часовой консультации ",
            "200 zł.",
            " полностью засчитывается в счет общей оплаты!",
          ],
          button: "Записаться на консультацию",
        },

        step2: {
          title: "ШАГ 2. ВЫБОР ФОРМАТА СОПРОВОЖДЕНИЯ",
          intro:
            "В зависимости от того, готовы ли вы контролировать весь процесс рассмотрения вашего дела самостоятельно или хотите полностью передать нам ведение всех административных формальностей, выберите подходящий пакет услуг:",
          packages: [
            {
              badge: "🔹",
              name: "БАЗОВЫЙ ПАКЕТ",
              description:
                "Техническая подготовка документов, заполнение и безопасная отправка заявления в системе MOS 2.0:",
              features: [
                "Помощь в создании вашего личного кабинета в системе MOS.",
                "Проверка и подготовка полного цифрового пакета документов в соответствии с требованиями ужонда.",
                "Совместное пошаговое заполнение заявления (вместе с вами в офисе нашей фирмы или на интерактивной онлайн-сессии).",
                "Личное подписание заявителем и отправка заявления в ужонд, скачивание официального подтверждения UPO (Urzędowe Poświadczenie Odbioru).",
              ],
              note: "Важно для тех, кто подается по работе: При необходимости мы берем на себя коммуникацию с вашей компанией, чтобы обеспечить корректное оформление документов для получения карты побыту на максимально возможный срок, предусмотренный законодательством.",
              pricesLabel: "Стоимость Базового пакета услуг:",
              prices: [
                "Временный / постоянный вид на жительство — 800 zł.",
                "Карта долгосрочного резидента ЕС — 1200 zł.",
              ],
              discount: "",
            },
            {
              badge: "🔸",
              name: "РАСШИРЕННЫЙ ПАКЕТ",
              description:
                "Официальное представительство и комплексное сопровождение вашего дела от А до Я. Дополнительно ко всем услугам Базового пакета мы полностью берем ведение вашего дела на себя на основании официальной доверенности (pełnomocnictwa):",
              features: [
                "Сопровождение на процедуру сдачи отпечатков пальцев с подготовкой полного пакета актуальных документов для личного визита в ужонд.",
                "Официальное получение всей корреспонденции из ужонда на наш адрес (это существенно снижает риск пропуска важной информации).",
                "Прямой контакт с инспектором, ведущим ваше дело, и оперативная подготовка ответов на любые запросы (wezwania).",
                "Постоянный контроль дела до момента вынесения и получения официального решения (decyzji).",
              ],
              note: "",
              pricesLabel: "Стоимость Расширенного пакета услуг:",
              prices: [
                "Временный / постоянный вид на жительство — 1600 zł.",
                "Карта долгосрочного резидента ЕС — 2000 zł.",
              ],
              discount:
                "Семейная скидка: При заказе Расширенного пакета для семьи действует скидка –25% на услуги для несовершеннолетних детей.",
            },
          ],
        },

        additional: {
          title: "ДОПОЛНИТЕЛЬНЫЕ УСЛУГИ",
          intro:
            "Что делать, если вы начали процесс легализации самостоятельно или воспользовались услугами других посредников, но ситуация вышла из-под контроля? Вы можете обратиться к нам в двух случаях:",
          items: [
            {
              title: "1. Аудит дела и сопровождение",
              text: "Ваше заявление (wniosek) уже подано, но инспектор присылает сложные запросы (wezwanie), работодатель не может разобраться с цифровым приложением, или вы просто не понимаете, что происходит с вашим делом? Мы проведем полный аудит вашего текущего дела, исправим допущенные ранее ошибки, оформим официальное представительство (pełnomocnictwo) и возьмем на себя дальнейшее ведение дела и взаимодействие с инспектором.",
              price:
                "Стоимость ведения дела согласовывается индивидуально, в зависимости от его текущего состояния и этапа рассмотрения.",
            },
            {
              title: "2. Защита ваших прав в случае официального отказа",
              text: "Если вы уже получили на руки отрицательное решение (decyzja odmowna), критически важно не упустить время. У вас есть ровно 14 дней с момента получения решения на то, чтобы оспорить решение ужонда. Мы детально изучим аргументы инспектора и, в случае реального шанса на успех, подготовим апелляцию (odwołanie).",
              price: "Стоимость подготовки апелляции — от 1500 zł.",
            },
          ],
        },

        footerNote: [
          "Все условия сотрудничества абсолютно прозрачны, одобряются до начала работы и строго фиксируются в официальном договоре.",
          "Государственные пошлины и иные официальные сборы оплачиваются отдельно.",
        ],
        button: "Записаться на консультацию по карте побыту",
      },

      // ============ SECTION 2: ГРАЖДАНСТВО ПОЛЬШИ ============
      citizenship: {
        title: "ПОМОЩЬ В ПОЛУЧЕНИИ ГРАЖДАНСТВА ПОЛЬШИ",
        intro: [
          "Получение польского паспорта – это итоговый этап миграционной интеграции, требующий внимательного отношения к каждой детали. Наша команда AGWIPOL помогает иностранцам тщательно подготовиться к этому процессу, правильно оформить заявление и собрать необходимый пакет документов в соответствии с актуальными требованиями.",
          "Мы не даем пустых обещаний и стопроцентных гарантий успеха, так как окончательное решение всегда остается за государственными органами. Наша задача – помочь вам надлежащим образом подготовить документы, минимизировать риск критических ошибок и представить обстоятельства, имеющие значение для рассмотрения дела:",
        ],
        services: [
          "проверим выполнение всех условий для получения гражданства;",
          "проанализируем документы на предмет ошибок и несоответствий;",
          "подготовим заявление и необходимые приложения;",
          "поможем собрать доказательства интеграции и проживания;",
          "при необходимости будем представлять ваши интересы по доверенности.",
        ],

        step1: {
          title: "ШАГ 1. ТРАНСКРИПЦИЯ ЗАГРАНИЧНЫХ АКТОВ ГРАЖДАНСКОГО СОСТОЯНИЯ",
          text: "Прежде чем приступать к процедуре получения гражданства Польши, необходимо убедиться, что иностранные акты гражданского состояния, подлежащие внесению в польские реестры, были надлежащим образом зарегистрированы в Польше. Речь может идти, в частности, о свидетельствах о рождении, заключении или расторжении брака, а также о смерти супруга. Транскрипция (umiejscowienie) иностранных документов проводится в органах ЗАГС (USC – Urząd Stanu Cywilnego) и является отдельной услугой. Подробнее о стоимости, сроках и особенностях процедуры вы можете узнать в соответствующем разделе сайта.",
          link: "👉 Иные услуги: Umiejscowienie",
        },

        step2: {
          title: "ШАГ 2. ВЫБОР СПОСОБА ПОЛУЧЕНИЯ ГРАЖДАНСТВА",
          intro:
            "Законодательство Польши предусматривает два механизма для получения польского паспорта. Оптимальный способ подбирается индивидуально, исходя из вашего правового статуса, продолжительности проживания в стране и имеющихся документов:",
          variant1: {
            title: "Вариант 1. Признание гражданином Польши (через Воеводу)",
            text: [
              "Это официальная административная процедура, которая подходит для иностранцев, легально проживающих в Польше в течение установленного законом срока. Заявление рассматривается Воеводой по месту вашего проживания.",
              "Поскольку польское законодательство предусматривает разные требования, пакеты документов и сроки проживания в зависимости от конкретного основания, мы проводим детальный аудит вашей ситуации на индивидуальной консультации, чтобы убедиться в выполнении всех критериев.",
            ],
            packages: [
              {
                name: "БАЗОВЫЙ ПАКЕТ — 1000 zł.",
                text: "Подробный разбор вашей ситуации, аудит имеющихся документов, заполнение официального заявления и необходимых согласий на польском языке для вашей самостоятельной подачи.",
              },
              {
                name: "РАСШИРЕННЫЙ ПАКЕТ — 1600 zł.",
                text: "Все опции базового пакета, а также последующее сопровождение дела на основании официальной доверенности (pełnomocnictwa). Мы берем на себя получение корреспонденции из ужонда, контакт с вашим инспектором и своевременную подготовку ответов на возможные официальные запросы (wezwania).",
              },
            ],
            button: "Записаться на консультацию по вопросам гражданства",
          },
          variant2: {
            title:
              "Вариант 2. Предоставление гражданства Президентом Республики Польша",
            text: [
              "Данная процедура является исключительным конституционным правом Президента Польши. Она не ограничена жесткими рамками: теоретически направить прошение может любой иностранец на любом этапе пребывания в стране.",
              "Однако важно понимать ключевые особенности этого процесса:",
            ],
            points: [
              "Процедура носит дискреционный характер и не содержит четко определённых критериев принятия решения. Именно поэтому данную процедуру иногда неофициально называют «миграционной лотереей».",
              "Отрицательное решение Президента является окончательным и не подлежит обжалованию или оспариванию в судебном порядке.",
              "Наша основная задача в данном случае – помочь вам максимально полно представить обстоятельства, подтверждающие ваши связи с Польшей, степень интеграции, достижения и иные аргументы, которые могут иметь значение при рассмотрении дела.",
            ],
            price: "Стоимость подготовки документов (базовый пакет) — 1000 zł.",
          },
        },

        footerNote: [
          "Все условия сотрудничества абсолютно прозрачны, одобряются до начала работы и строго фиксируются в официальном договоре.",
          "Государственные пошлины и иные официальные сборы оплачиваются отдельно.",
        ],
        button: "Записаться на консультацию по вопросам гражданства",
      },

      // ============ SECTION 3: ТРАНСКРИПЦИЯ (UMIEJSCOWIENIE) ============
      transcription: {
        title:
          "ТРАНСКРИПЦИЯ ЗАГРАНИЧНЫХ АКТОВ ГРАЖДАНСКОГО СОСТОЯНИЯ (UMIEJSCOWIENIE)",
        intro:
          "Помогаем внести иностранные свидетельства в польские реестры актов гражданского состояния.",
        text: "Если ваше свидетельство о рождении, браке, расторжении брака либо свидетельство о смерти супруга были выданы за пределами Польши, то для подачи документов на гражданство, а также для иных административных процедур (например, для получения ВНЖ по браку с гражданином Польши) вам необходимо пройти процедуру транскрипции (Transkrypcja / Umiejscowienie) – официального переноса содержания заграничного документа (свидетельства о рождении, браке, расторжении брака, смерти супруга) в польский государственный реестр. Процедура проводится в Управлении актов гражданского состояния (Urząd Stanu Cywilnego – USC).",
        servicesIntro:
          "Мы поможем вам пройти эту бюрократическую процедуру правильно и без лишнего стресса:",
        services: [
          "Проанализируем ваши свидетельства на предмет ошибок, неточностей или недостающих данных.",
          "Организуем выполнение присяжного перевода документа при необходимости.",
          "Подготовим официальное заявление (wniosek) и необходимые согласия (oświadczenia).",
          "При необходимости представим ваши интересы непосредственно в USC на основании специальной доверенности (pełnomocnictwo), избавив вас от необходимости личного визита.",
        ],
        price: [
          "Стоимость услуги: ",
          "200 zł.",
          " за один документ (государственная пошлина и услуги присяжного перевода оплачиваются отдельно).",
        ],
        button: "Подать заявку",

        additional: {
          title: "ДОПОЛНИТЕЛЬНЫЕ УСЛУГИ И АДМИНИСТРАТИВНОЕ СОПРОВОЖДЕНИЕ",
          intro:
            "Помогаем решить сопутствующие административные вопросы, необходимые для комфортной жизни и легального пребывания в Польше. Оказываем поддержку как при оформлении базовых документов, так и в нестандартных ситуациях, требующих индивидуального подхода.",

          basicTitle: "Оформление базовых документов для жизни в Польше.",
          basicSubtitle: [
            "Стоимость — ",
            "100 zł.",
            " за каждую отдельную услугу:",
          ],
          basicServices: [
            "Регистрация идентификационного номера PESEL.",
            "Создание и подтверждение Profil Zaufany – личной электронной подписи для доступа к государственным цифровым сервисам.",
            "Подключение к системе e-Doręczenia – официальному цифровому ящику для безопасного получения корреспонденции от государственных ведомств.",
            "Сопровождение при открытии банковского счёта.",
          ],
          basicNote:
            "Услуги данной категории обычно оказываются в течение одного рабочего дня по предварительной записи.",

          extraTitle: "Дополнительные административные услуги:",
          extraServices: [
            "Помощь в оформлении гостевого приглашения (zaproszenie) — 300 zł. / документ.",
            "Помощь в замене иностранного водительского удостоверения на польское — 300 zł. / документ.",
            "Сопровождение процедуры получения апостиля (apostille) — от 250 zł. / документ.",
            "Организация присяжного перевода документов (tłumaczenie przysięgłe) — от 70 zł. / страница.",
          ],

          complexTitle: "Комплексная поддержка в нестандартных ситуациях:",
          complexServices: [
            "Анализ документов и проверка соответствия текущего статуса требованиям законодательства.",
            "Поддержка и сопровождение процессов при смене работодателя.",
            "Подготовка официальных писем, заявлений и ведомственных обращений.",
            "Оформление детских и социальных выплат.",
            "Организационная помощь: подбор языковых курсов и запись на государственные экзамены.",
            "Анализ и сопровождение иных нестандартных миграционных и административных ситуаций.",
          ],
          complexNote: [
            "Стоимость услуг данной категории рассчитывается индивидуально по согласованию.",
            "Окончательный объём услуг утверждается перед началом работы и строго фиксируется в договоре.",
            "Государственные пошлины и иные официальные сборы оплачиваются отдельно.",
          ],

          importantNote: [
            "Важное примечание: мы не являемся агентством временного трудоустройства и не предоставляем услуги по поиску вакансий.",
            "Наша задача – профессиональный аудит документов, административное сопровождение и легализация вашего пребывания в стране.",
          ],
          button: "Записаться на консультацию",
        },
      },
    },

    faq: {
      header: "Часто задаваемые вопросы",
      buttonText: "Задать вопрос специалисту",

      links: {
        title: "📂 Полезные ссылки",
        intro:
          "Здесь вы можете найти подробные инструкции, которые мы подготовили, чтобы помочь вам сориентироваться в польских реалиях:",
        downloadBtn: "Скачать",
        items: [
          "Гид по переезду",
          "Первые шаги в Польше",
          "Инструкция: Profil Zaufany",
          "Инструкция: e-Doręczenia",
          "Инструкция: Справка из налоговой (Zaświadczenie o niezaleganiu w podatkach)",
          "Инструкция: Справка из ZUS об отсутствии задолженности по взносам",
          "Инструкция: Справка из ZUS о страховании членов семьи",
          "Инструкция: Справка из ZUS (US-7) — информация с индивидуального страхового счёта работника",
        ],
        freeNote: "Скачайте и используйте бесплатно",
        instagramTitle:
          "Больше полезного контента и оперативные новости – в нашем Instagram",
        instagramText:
          "Законы в Польше меняются быстро. Если вам нужны самые свежие новости, разборы новых правил и наш личный опыт в режиме реального времени – подписывайтесь на наш Instagram.",
        instagramBtn: "Перейти в Instagram",
      },

      general: {
        title: "ЧАСТО ЗАДАВАЕМЫЕ ВОПРОСЫ (FAQ) – ОБЩИЕ",
        q1: {
          q: "1. С чего лучше всего начать процесс легализации?",
          a: "Мы всегда рекомендуем начинать с индивидуальной консультации. Это позволяет детально разобрать вашу конкретную ситуацию, проверить имеющиеся документы на соответствие официальным требованиям и сразу выбрать наиболее надёжный путь легализации.",
        },
        q2: {
          q: "2. Занимаетесь ли вы сложными случаями или отказами?",
          a: "Да, мы работаем как с базовыми запросами, так и со сложными ситуациями, включая отказы.",
        },
        q3: {
          q: "3. Как выглядит процесс нашего сотрудничества?",
          intro:
            "Мы выстроили процесс так, чтобы он был для вас максимально понятным и предсказуемым. Сотрудничество проходит в несколько этапов:",
          steps: [
            {
              label: "Консультация и анализ:",
              text: "Мы разбираем вашу ситуацию, проверяем документы и подбираем оптимальный вариант легализации.",
            },
            {
              label: "Согласование и договор:",
              text: "Мы фиксируем финальный объём услуг и стоимость, после чего подписываем официальный договор.",
            },
            {
              label: "Подготовка и подача документов:",
              text: "Мы помогаем собрать полный пакет документов, заполняем и подаем заявление.",
            },
            {
              label: "Сопровождение:",
              text: "В случае необходимости, сопровождаем вас на каждом этапе – от сдачи отпечатков пальцев до коммуникации с инспектором и получения готового решения.",
            },
            {
              label: "Результат:",
              text: "Мы остаёмся на связи до момента получения вами децизии (решения) или пластиковой карты.",
            },
          ],
        },
        q4: {
          q: "4. Как сейчас происходит подача на карту побыта?",
          p1: "Оформление карты побыта полностью перешло в цифровую эпоху. С апреля 2026 года в Польше действует обновленная государственная система MOS 2.0, согласно которой заявления принимаются исключительно в электронном виде. Любые бумажные анкеты, отправленные почтой или поданные через канцелярию, теперь автоматически оставляются без рассмотрения (pozostawione bez rozpoznania).",
          p2: "Подача через интернет требует личной авторизации заявителя через login.gov.pl и подписания доверенным профилем (Profil Zaufany).",
          warning:
            "Помните: передавать доступы от своего профиля посредникам небезопасно и напрямую нарушает правила конфиденциальности.",
        },
        q5: {
          q: "5. Какой языковой экзамен сдавать для карты резидента и для получения гражданства?",
          p1: "На карту долгосрочного резидента ЕС для подтверждения знания польского языка на уровне B1 можно предоставить государственный сертификат, а также некоторые международные сертификаты (например, TELC или ECL на уровне B1 и выше) или справку из польского вуза (академического или публичного профиля) о том, что вы прошли там курс польского языка как иностранного.",
          p2: "На польское гражданство нужен только государственный сертификат (Państwowy certyfikat znajomości języka polskiego).",
          warningLabel: "Внимание:",
          warning1:
            "Детям до 16 лет (на момент подачи) подтверждать знание языка на карту резидента не нужно.",
          warning2:
            "С 1 июля 2026 года свидетельства об окончании полицеальных школ (szkoły policealne) больше НЕ ПРИНИМАЮТСЯ для подтверждения знания языка ни на карту резидента, ни на гражданство.",
        },
      },

      residence: {
        title:
          "ЧАСТО ЗАДАВАЕМЫЕ ВОПРОСЫ (FAQ) – ВИД НА ЖИТЕЛЬСТВО / КАРТА ПОБЫТА",
        q1: {
          q: "1. Могу ли я просто передать вам логин и пароль от своего Profil Zaufany, чтобы вы всё сделали сами?",
          p1: "Нет. Доверенный профиль (Profil Zaufany) – это ваша личная цифровая подпись в Польше, юридически равная вашей подписи от руки. Передавать доступы к ней третьим лицам небезопасно.",
          p2: "Мы работаем исключительно легально: готовим все документы заранее, а затем вместе с вами заходим в систему, заполняем и отправляем заявление (wniosek). Это гарантирует безопасность ваших данных и 100% точность заполнения.",
        },
        q2: {
          q: "2. Можно ли подать заявление в последний день легального пребывания?",
          p1: "Технически да, но это рискованно. Электронное заявление должно быть полностью сформировано и отправлено не позднее последнего дня вашего текущего легального пребывания в Польше (будь то виза, дни безвизового режима или срок действия предыдущей карты побыту). Заполнение заявления в системе требует времени: нужно внести все данные, загрузить документы и подписать заявление.",
          p2: "Чтобы избежать технических сбоев государственного сайта в последний момент и, в случае необходимости, спокойно скоординировать вашего работодателя для заполнения его части анкеты, мы настоятельно рекомендуем начинать подготовку дела, как минимум, за 1,5–2 месяца до окончания действия ваших текущих документов.",
        },
        q3: {
          q: "3. Что необходимо подготовить заранее перед подачей внеска в MOS 2.0?",
          intro:
            "Чтобы заранее подготовиться к заполнению заявления в системе MOS 2.0, вам необходимо иметь:",
          step1: {
            label: "Доступ к системе:",
            text: "Profil Zaufany (логин + пароль) – для регистрации в системе, входа и подписания заявления.",
          },
          step2: {
            label: "Цифровое фото:",
            text: "Файл с фотографией в формате JPG должен иметь размеры не менее 684 × 883 пикселей (с сохранением пропорции 35×45 мм), а его размер не должен превышать 2,5 МБ. Фото должно быть сделано не позже 6 месяцев перед подачей заявления.",
          },
          step3: {
            label: "E-mail работодателя",
            text: "(если подаете заявление на ВНЖ по работе): Туда придёт ссылка для заполнения załącznika nr 1.",
          },
          step4: {
            label: "Подтверждения оплат:",
            payments: [
              "от 340 zł. до 640 zł. (в зависимости от вида разрешения)",
              "100 zł. (за выдачу карты)",
              "17 zł. (если будет оформляться доверенность)",
            ],
          },
          step5: {
            label: "Сканы документов",
            text: "(.pdf, .jpg):",
            docs: [
              "паспорт (все страницы с отметками)",
              "в зависимости от ситуации: договор / разрешение на работу / ZUS (ZUA / RCA + UPO) / карта побыта + децизия / подтверждение дохода / договор аренды / другие дополнительные документы",
            ],
          },
          warningLabel: "Внимание:",
          warning:
            "Максимальный размер одного файла – до 10 MB, а общий объём всех прикреплённых документов в заявлении – до 50 MB.",
        },
        q4: {
          q: "4. Как мой работодатель заполнит załącznik nr 1, если у него нет доступа к моему кабинету в MOS 2.0?",
          intro:
            "Передавать доступы или логиниться в ваш кабинет работодателю не нужно, система MOS полностью защищает ваши личные данные. Процесс выглядит следующим образом:",
          steps: [
            "Вы указываете e-mail компании в специальном поле вашего электронного заявления.",
            "Как только вы нажимаете кнопку «Сохранить и отправить форму работодателю», на указанную почту вашей компании мгновенно уходит официальное письмо с уникальной ссылкой.",
            "Представитель компании переходит по ссылке, заполняет данные о вашей должности, условиях труда и зарплате прямо на государственном портале и подписывает форму своей электронной подписью (Profil Zaufany или квалифицированной подписью).",
            "Подписанный załącznik nr 1 автоматически подгружается в ваше электронное дело. Вам на почту приходит уведомление, что заявление готово к финальной подаче.",
          ],
          outro:
            "Если ваша компания или её HR-отдел ещё не сталкивались с новой процедурой MOS 2.0 и опасаются сделать ошибку, не волнуйтесь. При необходимости мы связываемся с вашей компанией, предоставляем им пошаговую инструкцию и контролируем, чтобы документ был подписан корректно для получения карты на максимальный срок (до 3 лет).",
        },
        q5: {
          q: "5. Как подать заявление на карту побыта для ребенка в MOS 2.0?",
          p1: "Главное правило, которое сбережёт ваши нервы: отдельный аккаунт для несовершеннолетнего ребёнка создавать НЕ нужно! Система устроена так, что профиль ребёнка создаётся исключительно внутри личного кабинета родителя или законного опекуна как зависимый профиль (subkonto).",
          p2: "Подробная инструкция – на нашей странице в Instagram.",
        },
        q6: {
          q: "6. Сколько времени ребёнок может находиться в Польше без оформления ВНЖ?",
          p1: "Ребёнок, родившийся в Польше у родителей-иностранцев, не получает автоматически разрешение на проживание (ВНЖ/ПМЖ), но его первоначальная легальность пребывания напрямую связана со статусом родителей.",
          p2: "Если ребёнок родился в период, когда у родителей (или одного из них) есть действующая национальная виза, разрешение на пребывание (Karta Pobytu) или другой легальный статус, его пребывание считается легальным в тот же период, что и легальный статус родителей.",
          warningLabel: "Важно:",
          warning:
            "Для легализации пребывания ребёнка необходимо подать ОТДЕЛЬНОЕ заявление на разрешение на пребывание строго до момента истечения легального статуса родителей (визы, карты или безвизового режима). Ребёнок НЕ «включается» в карту побыта родителей.",
          p3: "Чтобы исключить риски нарушения миграционного законодательства, мы рекомендуем запускать процесс легализации несовершеннолетнего сразу после получения польского свидетельства о рождении (Akt urodzenia).",
          p4: "Разрешение на пребывание для ребёнка предоставляется до окончания периода действия разрешения на пребывание родителя.",
        },
        q7: {
          q: "7. Можно ли выезжать в страну гражданства за визой во время ожидания карты побыта?",
          p1: "Официальный ответ ужонда: выезжать МОЖНО. Само по себе оставление территории РП в ходе длящегося производства не является основанием для закрытия дела и не ведет к оставлению заявления без рассмотрения или к прекращению производства. Если во время нахождения в стране гражданства вы успешно получаете новую национальную визу и по ней въезжаете обратно в Польшу, это никак не влияет на рассмотрение вашего заявления. Орган по-прежнему оценивает исключительно ваше соответствие стандартным условиям для выдачи ВНЖ согласно Закону об иностранцах.",
          p2: "Несмотря на то, что выезд за визой легален, длительное отсутствие в Польше сопряжено с серьезными юридическими и логистическими опасностями:",
          risks: [
            "Иностранец обязан ЛИЧНО ЯВИТЬСЯ В УЖОНД для сдачи отпечатков пальцев В СТРОГО ОПРЕДЕЛЕННЫЙ ДЕНЬ И ЧАС, указанные в официальном письме.",
            "Бумажное уведомление (wezwanie) отправляется заказным письмом на польский адрес проживания, указанный в анкете. Если вас нет в стране и некому проверить ваш почтовый ящик, вы просто НЕ УЗНАЕТЕ О НАЗНАЧЕННОЙ ДАТЕ.",
            "Если вы будете находиться за границей и пропустите назначенный день сдачи отпечатков, ваше заявление будет автоматически ОСТАВЛЕНО БЕЗ РАССМОТРЕНИЯ (pozostawienie wniosku bez rozpoznania) на основании ст. 105 п. 2 Закона об иностранцах. Восстановить процесс после этого практически невозможно, придется подаваться заново.",
            "Выезжая за новой визой, вы полностью отдаете себя на усмотрение консульства в своей стране. Если В ВЫДАЧЕ НОВОЙ НАЦИОНАЛЬНОЙ ВИЗЫ по какой-то причине будет ОТКАЗАНО (или процесс оформления затянется), вы потеряете возможность вовремя вернуться в Польшу к дате сдачи отпечатков, что автоматически погубит ваше дело по ВНЖ.",
          ],
        },
        q8: {
          q: "8. Отказ по карте побыта: когда и как подать апелляцию?",
          a: "Если вы получили решение с отказом и хотите его обжаловать (подать апелляцию / odwołanie), у вас есть 14 дней с даты получения решения. Апелляция подаётся через орган, который вынес решение (он сам перешлёт во II инстанцию). На конверте/в заявлении указывайте именно этот орган. Поданная в срок апелляция приостанавливает исполнение решения, а значит, ваше пребывание в Польше остается легальным.",
        },
      },

      citizenship: {
        title: "ЧАСТО ЗАДАВАЕМЫЕ ВОПРОСЫ (FAQ) – ГРАЖДАНСТВО ПОЛЬШИ",
        q1: {
          q: "1. Нужно ли отказываться от своего родного гражданства при получении польского паспорта?",
          p1: "С точки зрения законодательства Республики Польша, нет, отказываться от имеющегося гражданства не требуется. Действующий Закон «О польском гражданстве» (Ustawa o obywatelstwie polskim) не содержит норм, обязывающих иностранца оформлять выход из подданства своей страны при получении статуса гражданина РП.",
          p2: "Государство полностью толерантно относится к наличию у вас второго паспорта, но внутри страны и в официальных отношениях с польскими органами власти (судами, ужондами, налоговой, пограничной службой) вы будете рассматриваться исключительно как гражданин Польши. Наличие иного гражданства не может служить основанием для освобождения от обязанностей, предусмотренных польским законодательством.",
        },
        q2: {
          q: "2. Какой путь надежнее: через Воеводу или через Президента?",
          a: "Процедура через Воеводу более предсказуема, так как это административный процесс: если заявитель соответствует всем установленным законом условиям и предоставляет полный комплект документов, вероятность получения положительного решения является высокой. Прошение на имя Президента – это исключительный путь для тех, у кого нет какого-то из обязательных условий, но есть веские основания просить о гражданстве лично главу государства.",
        },
        q3: {
          q: "3. Можно ли подать документы Воеводе, если я еще только жду результатов экзамена по польскому языку?",
          a: "К сожалению, нет. Для Воеводы наличие государственного сертификата (или диплома) на уровне B1 – это строгое требование на момент регистрации дела. Подать заявление «авансом», а потом донести сертификат не получится. Ужонд просто вернет документы без рассмотрения.",
        },
        q4: {
          q: "4. Получает ли ребёнок автоматически гражданство Польши, если родился в Польше?",
          p1: "Нет. Сам факт рождения на территории Польши не даёт ни гражданства, ни автоматического права на проживание (ВНЖ/ПМЖ).",
          p2: "Гражданство Польши признается по праву крови (лат. – jus sanguinis). Это означает, что ребёнок получает гражданство, если на момент рождения хотя бы один из его родителей является гражданином Польши. В этом случае место рождения не имеет значения.",
          p3: "Если ни один из родителей не является гражданином Польши, гражданство ребёнка определяется по гражданству родителей.",
          p4: "Исключение, когда действует право почвы (лат. – jus soli) и ребёнок получает польское гражданство, – это очень редкие случаи, когда оба родителя неизвестны, не имеют гражданства или их гражданство не определено.",
        },
      },

      transcription: {
        title:
          "ЧАСТО ЗАДАВАЕМЫЕ ВОПРОСЫ (FAQ) – ТРАНСКРИПЦИЯ ЗАГРАНИЧНЫХ АКТОВ ГРАЖДАНСКОГО СОСТОЯНИЯ (Umiejscowienie)",
        q1: {
          q: "1. Остается ли оригинал моего заграничного свидетельства в польском ЗАГСе (USC) навсегда?",
          a: "Да. В большинстве случаев оригинал документа остаётся в материалах дела USC, поэтому перед подачей рекомендуется заранее позаботиться о получении повторного экземпляра (дубликата) документа в стране его выдачи. По результатам процедуры транскрипции вы получаете полноценный польский аналог – официальную выписку из реестра (odpis aktu stanu cywilnego).",
        },
        q2: {
          q: "2. Насколько сложно в будущем получить дубликат или выписку (odpis) польского свидетельства?",
          intro:
            "Это максимально простая процедура, так как все данные навсегда вносятся в центральный электронный реестр (Rejestr Stanu Cywilnego). Получить повторный документ можно двумя способами:",
          option1: {
            label: "Лично:",
            text: "В абсолютно любом ЗАГСе (USC) на территории всей Польши. Ехать именно в то отделение, которое делало первую транскрипцию, не нужно.",
          },
          option2: {
            label: "Онлайн:",
            text: "Через государственный портал gov.pl, авторизовавшись с помощью Profil Zaufany. Официальный цифровой дубликат с электронной подписью министерства придет прямо в ваш личный кабинет за считанные минуты.",
          },
        },
        q3: {
          q: "3. Какой срок действия у польского документа?",
          p1: "Согласно закону, выданные выписки из актов гражданского состояния не имеют срока давности и действительны бессрочно.",
          p2: "Однако на практике государственные органы устанавливают строгие внутренние регламенты. Так, например, выписка о заключении брака (odpis aktu małżeństwa) на дату подачи заявления о признании гражданином Польши должна быть выдана не ранее чем за 3 месяца. Ужонд должен быть уверен, что в акт гражданского состояния не были внесены служебные отметки (wzmianki dodatkowe), например, о расторжении брака или изменении личных данных супругов.",
        },
      },
    },

    contact: {
      header: `Контакты`,
      //form
      formName: "Имя*",
      formCompany: "Название фирмы",
      formEmail: "Email*",
      formSubject: "Тема*",
      formMessage: "Сообщение*",
      formMessagePlaceholder: "Введите сообщение...",
      formButton: "Отправить",
      formNameError1: "Пожалуйста, введите ваше имя",
      formNameError2: "Ваше имя не может быть короче 2 символов",
      formNameError3: "Ваше имя должно состоять только из букв",
      formEmailError1: "Пожалуйста, введите ваш адрес email",
      formEmailError2: "Пожалуйста, введите действительный адрес email",
      formSubjectError1: "Пожалуйста, укажите тему",
      formSubjectError2: "Тема сообщения не может быть короче 2 символов",
      formMessageError1: "Пожалуйста, напишите сообщение",
      formMessageError2: "Ваше сообщение должно содержать минимум 2 символа",
      //right column
      email: "Email",
      phones: "Контактные номера",
      address: "Адрес",
    },

    footer: {
      linksTitle: "Быстрые ссылки",
      infoTitle: "Информация",
      contactsTitle: "Контакты",
    },

    cookies: {
      header: "Политика файлов cookie",
      paragraph:
        'Сайт использует файлы cookie, благодаря которым он может работать лучше. Это упрощает взаимодействие с сайтом и делает его полезнее для вас, а также позволяет нам формировать статистику и улучшать функциональность сайта. Просим вас сделать правильный выбор относительно ваших предпочтений в отношении функционирования файлов cookie. Нажав "отклонить cookies", вы автоматически откажетесь от использования всех технологий, кроме технически необходимых. Нажав "настроить разрешения", вы можете на следующем шаге индивидуально настроить свои предпочтения в отношении дополнительных файлов cookie. Нажимая "я принимаю cookies", вы соглашаетесь на использование технологии cookies в соответствии с настройками вашего браузера.',
      acceptBtn: "Принять cookies",
      rejectBtn: "Отклонить cookies (кроме необходимых)",
      detailsBtn: "Настроить разрешения",
      functionalCheckbox: "Принять функциональные cookies",
      analyticalCheckbox: "Принять аналитические cookies",
      marketingCheckbox: "Принять рекламные cookies",
      saveBtn: "Сохранить настройки",
    },

    consent: {
      consentLink:
        "С информацией об обработке персональных данных можно ознакомиться ",
      consentLinkText: "здесь",
    },
  },

  Polish: {
    nav: {
      Russian: "Русский",
      Polish: "Polski",
      home: pageTitles.Polish.home,
      services: pageTitles.Polish.services,
      servicesResidence: "Karta pobytu",
      servicesCitizenship: "Obywatelstwo",
      servicesTranscription: "Transkrypcja aktów stanu cywilnego",
      servicesOther: "Inne usługi",
      knowledge: pageTitles.Polish.faq,
      knowledgeLinks: "Przydatne linki",
      knowledgeFaqGeneral: "FAQ: Pytania ogólne",
      knowledgeFaqResidence: "FAQ: Karta pobytu",
      knowledgeFaqCitizenship: "FAQ: Obywatelstwo",
      knowledgeFaqTranscription: "FAQ: Transkrypcja aktów stanu cywilnego",
      contact: pageTitles.Polish.contact,
      menu: "menu",
      privacyPolicy: "Polityka prywatności",
    },

    index: {
      // hero
      heroTitle: "KOMPLEKSOWA POMOC DLA CUDZOZIEMCÓW W POLSCE",
      heroSubtitleLine1:
        "Pomagamy cudzoziemcom legalnie żyć i pracować w Polsce",
      heroSubtitleLine2:
        "Przejmujemy wszystkie formalności i towarzyszymy aż do uzyskania decyzji",

      // offer — три блока услуг
      offerDocsHeader: "UZYSKANIE PODSTAWOWYCH DOKUMENTÓW DO ŻYCIA W POLSCE",
      offerDocsText:
        "Pomagamy sprawnie dopełnić pierwszych formalności dla komfortowego startu i integracji: od nadania numeru PESEL i otwarcia konta bankowego, po założenie Profilu Zaufanego oraz konfigurację oficjalnej skrzynki e-Doręczenia.",
      offerDocsLink: "Więcej o dokumentach →",

      offerLegalizationHeader: "LEGALIZACJA POBYTU",
      offerLegalizationText:
        "Pomagamy przygotować i złożyć dokumenty o zezwolenie na pobyt czasowy (w tym Blue Card), pobyt stały, pobyt rezydenta długoterminowego UE oraz o obywatelstwo polskie. Pełne wsparcie eksperckie aż do uzyskania decyzji.",
      offerLegalizationLink1: "Więcej o kartach pobytu →",
      offerLegalizationLink2: "Więcej o obywatelstwie →",

      offerSupportHeader: "WSPARCIE I OPIEKA",
      offerSupportText:
        "Pomagamy odnaleźć się w skomplikowanych sytuacjach i zrozumieć wszelkie niuanse życia w Polsce: legalność zatrudnienia, zmiana pracodawcy, przygotowywanie pism urzędowych i odwołań, wymiana prawa jazdy, kursy i egzaminy językowe, tłumaczenia przysięgłe oraz apostille. Chronimy Państwa interesy w niestandardowych sytuacjach.",
      offerSupportLink: "Więcej o innych usługach →",

      // consultation
      consultationTitle: "Zacznijmy od analizy państwa sytuacji",
      consultationSubtitle:
        "Prosimy o wybór dogodnego terminu, godziny oraz preferowanej formy kontaktu (telefonicznie, online lub stacjonarnie)",
      consultationList: [
        "Samodzielnie wybierają Państwo dogodny termin",
        "Potwierdzenie zaraz po rezerwacji",
        "Przypomnienie przed rozmową",
      ],
      consultationNote:
        "Odpowiemy na Państwa pytania i pomożemy wybrać najlepsze rozwiązanie",
      consultationButton: "Wybierz termin",

      // shared form feedback (используется на странице контактов)
      formSuccessTitle: "Sukces!",
      formSuccessText: "Skontaktujemy się z tobą w najkrutszym okresie!",
      formErrorTitle: "Błąd!",
      formErrorText: "Coś poszło nie tak",
      formErrorButton: "Zamknij",
      formConsentData:
        "Wyrażam zgodę na przetwarzanie przez AgwiPol Sp. z o.o. moich danych osobowych w celu umożliwienia kontaktu drogą elektroniczną poprzez formularz na stronie internetowej bądź oddzwonienia na podany numer telefonu.*",
      formConsentDoc:
        "Oświadczam, że zapoznałam/em się z treścią informacji o przetwarzaniu danych osobowych i rozumiem jej treść.*",
      formConsentLink: "Informacja o przetwarzaniu danych osobowych dostępna ",
      formConsentLinkText: "TUTAJ",

      // callback form (used by the FAQ page)
      formTitle: "Skontaktuj się z nami",
      formIntroTitle:
        "Masz jeszcze pytania? Zostaw dane kontaktowe, a skontaktujemy się z Tobą",
      formBenefits: [
        "Oddzwonimy w godzinach pracy",
        "Odpowiemy na Twoje pytania",
        "Przeanalizujemy Twoją sytuację i podpowiemy możliwe rozwiązania",
      ],
      formName: "Imię:",
      formNameErrorLength1: "Proszę podać swoje imię",
      formNameErrorLength2: "Imię nie może być krótsze niż 2 litery",
      formNameErrorLetters: "Imię musi składać się wyłącznie z liter",
      formNamePlaceholder: "Wpisz swoję imię",
      formNumber: "Numer telefonu:",
      formNumberErrorLength1: "Proszę podać swój numer telefonu",
      formNumberErrorLength2: "Numer telefonu nie może być krótszy niż 7 cyfr",
      formNumberErrorFormat:
        "Proszę wpisać numer telefonu w formacie międzynarodowym (+48)",
      formNumberPlaceholder: "Wpisz swój numer",
      formButton: "Zadzwoń do mnie",

      // principles
      principlesStats: [
        {
          value: "9+",
          label:
            "lat doświadczenia w legalizacji pobytu i przygotowaniu dokumentów w Polsce",
        },
        {
          value: "5000+",
          label: "zakończonych sukcesem spraw i zadowolonych klientów",
        },
        {
          value: "95%",
          label: "klientów wraca do nas i poleca nas swoim znajomym",
        },
      ],
      principlesTitle:
        "Naszym zadaniem jest sprawić, aby proces załatwiania formalności urzędowych w Polsce był dla Państwa maksymalnie zrozumiały, spokojny i przewidywalny.",
      principlesIntroLead:
        "Nasze podejście do pracy opiera się na własnych doświadczeniach związanych z przeprowadzką i życiem w Polsce.",
      principlesChallengesIntro:
        "W praktyce zetknęliśmy się z tym, jak skomplikowane i niejasne mogą być:",
      principlesChallenges: [
        "legalizacja pobytu",
        "przygotowanie dokumentów",
        "kontakt z urzędami i instytucjami państwowymi w Polsce",
      ],
      principlesChallengesOutro:
        "Wiele pytań, sprzeczne informacje oraz brak jasnego planu działania utrudniają cały proces i zwiększają ryzyko popełnienia błędów.",
      principlesGoalsIntro:
        "Dlatego wypracowaliśmy taki sposób współpracy, dzięki któremu nasi klienci wiedzą:",
      principlesGoals: [
        "jakie dokumenty są potrzebne",
        "jakie kroki należy podjąć",
        "jak sprawdzić, czy wszystko zostało przygotowane prawidłowo",
        "na co warto zwrócić uwagę na każdym etapie",
      ],
      principlesExperience1:
        "Od 2017 roku wspieramy cudzoziemców w sprawach związanych z legalizacją pobytu i przygotowaniem dokumentów w Polsce.",
      principlesExperience2:
        "Pracujemy zarówno z podstawowymi sprawami, jak i bardziej skomplikowanymi przypadkami, w tym odmowami i niestandardowymi sytuacjami.",
      principlesTitle2: "Nasze zasady pracy",
      principlesFirstHeader: "Przejrzystość i odpowiedzialność",
      principlesFirstParagraph:
        "Wszystkie warunki współpracy są jasno określone w umowie. Wyjaśniamy sposób działania i możliwe rozwiązania. Dbamy o zgodność dokumentów z obowiązującymi przepisami prawa.",
      principlesSecondHeader: "Indywidualne podejście",
      principlesSecondParagraph:
        "Każdą sprawę analizujemy indywidualnie. Podejmujemy się tylko spraw, w których możemy realnie pomóc. Przestrzegamy zasad poufności oraz ochrony danych osobowych.",
      principlesThirdHeader: "Wsparcie aż do zakończenia sprawy",
      principlesThirdParagraph:
        "Towarzyszymy na każdym etapie sprawy. Pozostajemy w kontakcie aż do uzyskania decyzji.",

      // trust
      trustTitle: "Klienci nam ufają",
    },

    services: {
      header: "USŁUGI",

      residence: {
        title: "POMOC W UZYSKANIU ZEZWOLENIA NA POBYT W POLSCE (KARTA POBYTU)",
        intro:
          "Pomagamy w przygotowaniu i złożeniu dokumentów, a także zapewniamy kompleksowe wsparcie na każdym etapie legalizacji pobytu, niezależnie od podstawy prawnej (praca, działalność gospodarcza, połączenie z rodziną, Karta Polaka i inne), aż do momentu uzyskania",
        cards: [
          "Karta czasowego pobytu (zezwolenie na pobyt czasowy), w tym Niebieska Karta UE (Blue Card UE) dla wysoko wykwalifikowanych specjalistów",
          "Karta stałego pobytu (zezwolenie na pobyt stały)",
          "Karta rezydenta długoterminowego UE (zezwolenie na pobyt rezydenta długoterminowego UE)",
        ],
        disclaimer: [
          "Nie składamy pustych obietnic ani nie dajemy stuprocentowych gwarancji sukcesu, ponieważ ostateczna decyzja zawsze należy do organów państwowych. Naszym zadaniem jest zminimalizowanie ryzyka krytycznych błędów przy składaniu dokumentów i pomoc Państwu w osiągnięciu zamierzonego celu.",
          "Naszą pracę zorganizowaliśmy tak, aby cały proces był dla klienta przejrzysty i przewidywalny. Współpraca składa się z dwóch głównych etapów",
        ],

        step1: {
          title: "KROK 1. ANALIZA SYTUACJI I AUDYT PODSTAW PRAWNYCH",
          text: "Każda sprawa jest wyjątkowa. Szczegółowo analizujemy Państwa sytuację, weryfikujemy posiadane dokumenty pod kątem zgodności z aktualnymi wymogami prawnymi i dobieramy najbezpieczniejszą ścieżkę legalizacji. Podejmujemy się prowadzenia wyłącznie tych spraw, w których obiektywnie możemy przynieść realną korzyść.",
          options: [
            "Wstępna ekspresowa konsultacja (do 15 minut) — bezpłatnie",
            "Pełna konsultacja (do 1 godziny) — 200 zł.",
          ],
          important: [
            "WAŻNE: W przypadku podjęcia dalszej współpracy w ramach Pakietu Podstawowego lub Rozszerzonego, koszt godzinnej konsultacji ",
            "200 zł.",
            " zostaje w całości zaliczony na poczet całkowitej opłaty!",
          ],
          button: "Zapisz się na konsultację",
        },

        step2: {
          title: "KROK 2. WYBÓR FORMATU WSPÓŁPRACY",
          intro:
            "W zależności od tego, czy są Państwo gotowi samodzielnie kontrolować cały proces rozpatrywania sprawy, czy też chcą Państwo w pełni powierzyć nam prowadzenie wszystkich formalności administracyjnych, prosimy o wybór odpowiedniego pakietu usług:",
          packages: [
            {
              badge: "🔹",
              name: "PAKIET PODSTAWOWY",
              description:
                "Techniczne przygotowanie dokumentów, wypełnienie oraz bezpieczne wysłanie wniosku w systemie MOS 2.0:",
              features: [
                "Pomoc w założeniu Państwa konta osobistego w systemie MOS.",
                "Weryfikacja i przygotowanie pełnego cyfrowego pakietu dokumentów zgodnie z wymogami urzędu.",
                "Wspólne wypełnianie wniosku krok po kroku (z Państwa udziałem w biurze naszej firmy lub podczas interaktywnej sesji online).",
                "Osobiste podpisanie wniosku przez wnioskodawcę, wysłanie go do urzędu oraz pobranie oficjalnego poświadczenia UPO (Urzędowe Poświadczenie Odbioru).",
              ],
              note: "Ważne dla osób składających wniosek na podstawie pracy: W razie potrzeby bierzemy na siebie komunikację z Państwa firmą, aby zapewnić prawidłowe sporządzenie dokumentów w celu uzyskania karty pobytu na maksymalny możliwy okres przewidziany przez przepisy prawne.",
              pricesLabel: "Koszt Pakietu Podstawowego:",
              prices: [
                "Zezwolenie na pobyt czasowy / stały — 800 zł.",
                "Karta rezydenta długoterminowego UE — 1200 zł.",
              ],
              discount: "",
            },
            {
              badge: "🔸",
              name: "PAKIET ROZSZERZONY",
              description:
                "Oficjalne pełnomocnictwo i kompleksowe prowadzenie Państwa sprawy od A do Z.",
              features: [
                "Towarzyszenie podczas procedury pobierania odcisków palców wraz z przygotowaniem pełnego pakietu aktualnych dokumentów na potrzeby osobistej wizyty w urzędzie.",
                "Oficjalny odbiór całej korespondencji z urzędu na nasz adres (co istotnie zmniejsza ryzyko przeoczenia ważnych informacji lub niedotrzymania terminów).",
                "Bezpośredni kontakt z inspektorem prowadzącym Państwa sprawę oraz sprawne przygotowywanie odpowiedzi na wszelkie wezwania urzędowe.",
                "Stały monitoring sprawy aż do momentu wydania i odebrania oficjalnej decyzji.",
              ],
              note: "",
              pricesLabel: "Koszt Pakietu Rozszerzonego:",
              prices: [
                "Zezwolenie na pobyt czasowy / stały — 1600 zł.",
                "Karta rezydenta długoterminowego UE — 2000 zł.",
              ],
              discount:
                "Zniżka rodzinna: Przy zamówieniu Pakietu Rozszerzonego dla rodziny przysługuje zniżka –25% na usługi dla małoletnich dzieci.",
            },
          ],
        },

        additional: {
          title: "USŁUGI DODATKOWE",
          intro:
            "Co zrobić, jeśli rozpoczęli Państwo proces legalizacji samodzielnie lub skorzystali z usług innych pośredników, ale sytuacja wymknęła się spod kontroli? Mogą Państwo zwrócić się do nas w dwóch przypadkach:",
          items: [
            {
              title: "1. Audyt sprawy i asysta",
              text: "Państwa wniosek został już złożony, ale inspektor wysyła skomplikowane wezwania, pracodawca nie radzi sobie z aplikacją cyfrową lub po prostu nie wiedzą Państwo, co dzieje się ze sprawą? Przeprowadzimy kompletny audyt Państwa obecnej sprawy, skorygujemy dotychczasowe błędy, zgłosimy się do postępowania jako oficjalny pełnomocnik  i przejmiemy dalsze prowadzenie sprawy oraz komunikację z inspektorem.",
              price:
                "Koszt prowadzenia sprawy jest ustalany indywidualnie, w zależności od jej obecnego stanu oraz etapu rozpatrywania",
            },
            {
              title: "2. Ochrona Państwa praw w przypadku decyzji odmownej",
              text: "Jeśli otrzymali już Państwo do rąk decyzję odmowną, kluczowe znaczenie ma czas. Mają Państwo dokładnie 14 dni od momentu doręczenia pisma na to, aby odwołać się od rozstrzygnięcia urzędu. Szczegółowo przeanalizujemy argumentację inspektora i, przy realnych szansach na sukces, przygotujemy oficjalne odwołanie.",
              price: "Koszt przygotowania odwołania — od 1500 zł.",
            },
          ],
        },

        footerNote: [
          "Wszystkie warunki współpracy są w pełni przejrzyste, uzgadniane przed rozpoczęciem działań i ściśle określane w oficjalnej umowie.",
          "Opłaty skarbowe oraz inne oficjalne opłaty urzędowe są płatne osobno.",
        ],
        button: "Zapisz się na konsultację w sprawie karty pobytu",
      },

      citizenship: {
        title: "POMOC W UZYSKANIU OBYWATELSTWA POLSKIEGO",
        intro: [
          "Uzyskanie polskiego paszportu to końcowy etap integracji migracyjnej, wymagający szczególnej uwagi i dbałości o każdy detal. Nasz zespół AGWIPOL pomaga cudzoziemcom starannie przygotować się do tego procesu, prawidłowo sporządzić wniosek oraz zgromadzić niezbędny pakiet dokumentów zgodnie z aktualnymi wymogami.",
          "Nie składamy pustych obietnic ani nie dajemy stuprocentowych gwarancji sukcesu, ponieważ ostateczna decyzja zawsze należy do organów państwowych. Naszym zadaniem jest zminimalizowanie ryzyka krytycznych błędów przy wypełnianiu dokumentów i pomoc Państwu w zbudowaniu silnej, uargumentowanej pozycji:",
        ],
        services: [
          "Zweryfikujemy spełnienie wszystkich warunków niezbędnych do uzyskania obywatelstwa;",
          "Przeanalizujemy dokumenty pod kątem błędów i niezgodności;",
          "Przygotujemy wniosek wraz z wymaganymi załącznikami;",
          "Pomożemy zgromadzić dowody integracji i zamieszkiwania w kraju;",
          "W razie potrzeby będziemy reprezentować Państwa interesy na podstawie pełnomocnictwa.",
        ],

        step1: {
          title: "Krok 1. TRANSKRYPCJA ZAGRANICZNYCH AKTÓW STANU CYWILNEGO",
          text: "Przed przystąpieniem do procedury uzyskania obywatelstwa polskiego należy upewnić się, że zagraniczne akty stanu cywilnego, podlegające wpisowi do polskich rejestrów, zostały prawidłowo zarejestrowane w Polsce. Może to dotyczyć w szczególności aktów urodzenia, małżeństwa, rozwodu lub zgonu współmałżonka. Transkrypcja (umiejscowienie) dokumentów zagranicznych odbywa się w Urzędach Stanu Cywilnego (USC) i stanowi oddzielną usługę. Szczegółowe informacje o kosztach, terminach i specyfice tej procedury znajdą Państwo w odpowiedniej sekcji naszej strony.",
          link: "👉 Inne usługi: Umiejscowienie ",
        },

        step2: {
          title: "KROK 2. WYBÓR SPOSOBU UZYSKANIA OBYWATELSTWA",
          intro:
            "Przepisy prawa w Polsce przewidują dwa mechanizmy uzyskania polskiego paszportu. Optymalny sposób dobierany jest indywidualnie, w zależności od Państwa statusu formalnego, czasu zamieszkiwania w kraju oraz posiadanych dokumentów:",
          variant1: {
            title: "Opcja 1. Uznanie za obywatela polskiego (przez Wojewodę)",
            text: [
              "Jest to oficjalna procedura administracyjna przeznaczona dla cudzoziemców, którzy mieszkają w Polsce legalnie przez okres wymagany przepisami prawa. Wniosek rozpatrywany jest przez Wojewodę właściwego ze względu na Państwa miejsce zamieszkania.",
              "Ponieważ polskie przepisy przewidują zróżnicowane wymogi, pakiety dokumentów oraz okresy zamieszkania w zależności od konkretnej podstawy prawnej uznania za obywatela polskiego, przeprowadzamy szczegółowy audyt Państwa sytuacji podczas indywidualnej konsultacji, aby upewnić się, że wszystkie kryteria zostały spełnione.",
            ],
            packages: [
              {
                name: "PAKIET PODSTAWOWY — 1000 zł.",
                text: "Zakres usługi: Szczegółowa analiza Państwa sytuacji, audyt posiadanych dokumentów, wypełnienie oficjalnego wniosku oraz wymaganych oświadczeń w języku polskim do Państwa samodzielnego złożenia.",
              },
              {
                name: "PAKIET ROZSZERZONY — 1600 zł.",
                text: "Zakres usługi: Wszystkie opcje z Pakietu Podstawowego, a także późniejsze prowadzenie sprawy na podstawie oficjalnego pełnomocnictwa. Przejmujemy odbiór korespondencji z urzędu, kontakt z inspektorem prowadzącym sprawę oraz terminowe przygotowywanie odpowiedzi na ewentualne oficjalne wezwania.",
              },
            ],
            button: "Zapisz się na konsultację w sprawie obywatelstwa",
          },
          variant2: {
            title:
              "Opcja 2. Nadanie obywatelstwa przez Prezydenta Rzeczypospolitej Polskiej",
            text: [
              "Procedura ta stanowi wyłączne uprawnienie konstytucyjne Prezydenta RP. Nie jest ona ograniczona sztywnymi ramami prawnymi: teoretycznie wniosek może skierować każdy cudzoziemiec na dowolnym etapie swojego pobytu w kraju.",
              "Jednakże kluczowe jest zrozumienie specyfiki tego procesu:",
            ],
            points: [
              "W tym przypadku nie istnieją jasno określone kryteria sukcesu, a decyzja podejmowana jest uznaniowo, dlatego procedura ta bywa nieoficjalnie nazywana „loterią migracyjną”.",
              "Odmowa nadania obywatelstwa przez Prezydenta ma charakter dyskrecjonalny, jest ostateczna i nie podlega zaskarżeniu do sądu administracyjnego.",
              "Naszym głównym zadaniem w tym przypadku jest pomoc Państwu w jak najpełniejszym przedstawieniu okoliczności potwierdzających więzi z Polską, stopień integracji, osiągnięcia oraz inne argumenty, które mogą mieć znaczenie przy rozpatrywaniu sprawy.",
            ],
            price:
              "Koszt przygotowania dokumentów (Pakiet Podstawowy) — 1000 zł.",
          },
        },

        footerNote: [
          "Wszystkie warunki współpracy są w pełni przejrzyste, uzgadniane przed rozpoczęciem działań i ściśle określane w oficjalnej umowie.",
          "Opłaty skarbowe oraz inne oficjalne opłaty urzędowe są płatne osobno.",
        ],
        button: "Zapisz się na konsultację w sprawie obywatelstwa",
      },

      transcription: {
        title:
          "TRANSKRYPCJA ZAGRANICZNYCH AKTÓW STANU CYWILNEGO (UMIEJSCOWIENIE)",
        intro:
          "Pomagamy w rejestracji zagranicznych aktów w polskich rejestrach stanu cywilnego.",
        text: "Jeśli Państwa akt urodzenia, małżeństwa, rozwodu lub akt zgonu współmałżonka zostały wydane poza granicami Polski, to w celu złożenia dokumentów o obywatelstwo, jak również na potrzeby innych procedur administracyjnych (na przykład uzyskania zezwolenia na pobyt jako małżonka obywatela Polski), konieczne jest przeprowadzenie procedury transkrypcji (Transkrypcja / Umiejscowienie) – oficjalnego przeniesienia treści zagranicznego dokumentu (aktu urodzenia, małżeństwa, rozwodu, zgonu współmałżonka) do polskiego rejestru państwowego. Procedura ta jest prowadzona w Urzędzie Stanu Cywilnego (USC).",
        servicesIntro:
          "Pomagamy przejść przez tę procedurę biurokratyczną prawidłowo i bez zbędnego stresu: ",
        services: [
          "Przeanalizujemy Państwa akty pod kątem błędów, nieścisłości lub brakujących danych;",
          "Zorganizujemy wykonanie tłumaczenia przysięgłego dokumentu, jeśli będzie to wymagane;",
          "Przygotujemy oficjalny wniosek oraz niezbędne oświadczenia;",
          "W razie potrzeby będziemy reprezentować Państwa interesy bezpośrednio w USC na podstawie specjalnego pełnomocnictwa, zdejmując z Państwa konieczność osobistej wizyty.",
        ],
        price: [
          "Koszt usługi: ",
          "200 zł.",
          " za jeden dokument (opłata skarbowa oraz usługi tłumacza przysięgłego są płatne osobno).",
        ],
        button: "Złóż wniosek",

        additional: {
          title: "USŁUGI DODATKOWE I WSPARCIE ADMINISTRACYJNE",
          intro:
            "Pomagamy w rozwiązywaniu towarzyszących kwestii administracyjnych, niezbędnych do komfortowego życia i legalnego pobytu w Polsce. Świadczymy wsparcie zarówno przy załatwianiu podstawowych dokumentów, jak i w niestandardowych sytuacjach wymagających indywidualnego podejścia.",

          basicTitle: "Uzyskiwanie podstawowych dokumentów do życia w Polsce",
          basicSubtitle: [
            "Koszt — ",
            "100 zł.",
            " za każdą pojedynczą usługę (oficjalne opłaty urzędowe są płatne osobno):",
          ],
          basicServices: [
            "Rejestracja numeru identyfikacyjnego PESEL.",
            "Utworzenie i potwierdzenie Profilu Zaufanego – osobistego podpisu elektronicznego służącego do dostępu do państwowych usług cyfrowych.",
            "Podłączenie do systemu e-Doręczenia – oficjalnej skrzynki cyfrowej do bezpiecznego odbierania korespondencji od organów państwowych.",
            "Wsparcie przy otwieraniu konta bankowego. ",
          ],
          basicNote:
            "Usługi w tej kategorii są zazwyczaj świadczone w ciągu jednego dnia roboczego po wcześniejszym umówieniu wizyty.",

          extraTitle: "Dodatkowe usługi administracyjne:",
          extraServices: [
            "Pomoc w uzyskaniu zaproszenia dla cudzoziemca (wpis do ewidencji zaproszeń) — 300 zł. / dokument.",
            "Pomoc w wymianie zagranicznego prawa jazdy na polskie — 300 zł. / dokument.",
            "Asysta w procedurze uzyskania apostille (apostille) — od 250 zł. / dokument.",
            "Organizacja tłumaczenia przysięgłego dokumentów (tłumaczenie przysięgłe) — od 70 zł. / strona.",
          ],

          complexTitle: "Kompleksowe wsparcie w niestandardowych sytuacjach:",
          complexServices: [
            "Analiza dokumentów i weryfikacja zgodności obecnego statusu z wymogami przepisów prawa;",
            "Wsparcie i asysta w procesach związanych ze zmianą pracodawcy;",
            "Przygotowywanie oficjalnych pism, wniosków oraz odwołań i wystąpień do urzędów;",
            "Pomoc w uzyskaniu świadczeń na dzieci oraz innych zasiłków socjalnych;",
            "Pomoc organizacyjna: dobór certyfikowanych kursów językowych oraz zapisy na państwowe egzaminy certyfikatowe z języka polskiego;",
            "Analiza i prowadzenie innych niestandardowych sytuacji migracyjnych oraz administracyjnych.",
          ],
          complexNote: [
            "Koszt usług w tej kategorii: jest ustalany indywidualnie w drodze uzgodnień.",
            "Ostateczny zakres usług jest zatwierdzany przed rozpoczęciem współpracy i ściśle określany w umowie.",
            "Opłaty skarbowe oraz inne oficjalne opłaty urzędowe są płatne osobno.",
          ],

          importantNote: [
            "Ważna uwaga: Nie jesteśmy agencją pracy tymczasowej i nie świadczymy usług w zakresie pośrednictwa pracy ani poszukiwania wakatów.",
            "Naszym zadaniem jest profesjonalny audyt dokumentów, wsparcie administracyjne, komunikacja z urzędami oraz kompleksowa legalizacja Państwa pobytu w kraju.",
          ],
          button: "Zapisz się na konsultację",
        },
      },
    },

    faq: {
      header: "Najczęściej zadawane pytania",
      buttonText: "Zadaj pytanie",

      links: {
        title: "📂 Przydatne linki",
        intro:
          "Tutaj znajdą Państwo szczegółowe instrukcje w języku rosyjskim, które przygotowaliśmy, aby pomóc Państwu odnaleźć się w polskiej rzeczywistości:",
        downloadBtn: "Pobierz",
        items: [
          "Przewodnik po przeprowadzce",
          "Pierwsze kroki w Polsce",
          "Instrukcja: Profil Zaufany",
          "Instrukcja: e-Doręczenia",
          "Instrukcja: Zaświadczenie o niezaleganiu w podatkach (Urząd Skarbowy)",
          "Instrukcja: Zaświadczenie z ZUS o niezaleganiu w opłacaniu składek",
          "Instrukcja: Zaświadczenie z ZUS o zgłoszeniu członków rodziny do ubezpieczenia",
          "Instrukcja: Zaświadczenie z ZUS (US-7) -  informacja z indywidualnego konta ubezpieczonego",
        ],
        freeNote: "Darmowe materiały do pobrania",
        instagramTitle:
          "Więcej przydatnych treści i aktualnych wiadomości – na naszym Instagramie",
        instagramText:
          "Prawo w Polsce zmienia się szybko. Jeśli potrzebują Państwo najświeższych wiadomości, analiz nowych przepisów oraz naszego osobistego doświadczenia w czasie rzeczywistym – zapraszamy do obserwowania naszego profilu na Instagramie.",
        instagramBtn: "Przejdź do Instagrama",
      },

      general: {
        title: "NAJCZĘŚCIEJ ZADAWANE PYTANIA (FAQ) – OGÓLNE",
        q1: {
          q: "1. Od czego najlepiej zacząć proces legalizacji?",
          a: "Zawsze zalecamy rozpoczęcie od indywidualnej konsultacji. Pozwala to na szczegółową analizę Państwa konkretnej sytuacji, sprawdzenie posiadanych dokumentów pod kątem oficjalnych wymogów i natychmiastowe wybranie najbezpieczniejszej ścieżki legalizacji.",
        },
        q2: {
          q: "2. Zajmujecie się trudnymi przypadkami lub odmowami?",
          a: "Tak, pracujemy zarówno z podstawowymi zgłoszeniami, jak i ze skomplikowanymi sytuacjami, w tym z decyzjami odmownymi.",
        },
        q3: {
          q: "3. Jak wygląda proces naszej współpracy?",
          intro:
            "Zaprojektowaliśmy ten proces tak, aby był dla Państwa jasny i przewidywalny. Współpraca odbywa się w kilku etapach:",
          steps: [
            {
              label: "Konsultacja i analiza:",
              text: "Analizujemy Państwa sytuację, sprawdzamy dokumenty i dobieramy optymalny wariant legalizacji.",
            },
            {
              label: "Ustalenia i umowa:",
              text: "Ustalamy ostateczny zakres usług oraz cenę, po czym podpisujemy oficjalną umowę.",
            },
            {
              label: "Przygotowywanie i złożenie dokumentów:",
              text: "Pomagamy zgromadzić pełen pakiet dokumentów, wypełniamy i składamy wniosek.",
            },
            {
              label: "Wsparcie/Asysta:",
              text: "W razie potrzeby towarzyszymy Państwu na każdym etapie – od pobrania odcisków palców po kontakt z inspektorem i odbiór gotowej decyzji.",
            },
            {
              label: "Rezultat:",
              text: "Pozostajemy w kontakcie do momentu otrzymania przez Państwa decyzji lub karty pobytu.",
            },
          ],
        },
        q4: {
          q: "4. Jak obecnie wygląda składanie wniosku o kartę pobytu?",
          p1: "Procedura ubiegania się o kartę pobytu w pełni wkroczyła w erę cyfrową. Od kwietnia 2026 roku w Polsce działa zaktualizowany system państwowy MOS 2.0, zgodnie z którym wnioski przyjmowane są wyłącznie w formie elektronicznej. Wszelkie wnioski papierowe wysłane pocztą lub złożone w biurze podawczym (kancelarii) są teraz automatycznie pozostawiane bez rozpoznania.",
          p2: "Złożenie wniosku przez internet wymaga osobistej autoryzacji wnioskodawcy poprzez login.gov.pl i podpisania go Profilem Zaufanym.",
          warning:
            "Należy pamiętać: przekazywanie danych dostępowych do swojego profilu pośrednikom jest niebezpieczne i stanowi bezpośrednie naruszenie zasad poufności.",
        },
        q5: {
          q: "5. Jaki egzamin językowy należy zdać na kartę rezydenta, a jaki w celu uzyskania obywatelstwa?",
          p1: "Do wniosku o zezwolenie na pobyt rezydenta długoterminowego UE, w celu potwierdzenia znajomości języka polskiego na poziomie B1, można przedstawić certyfikat państwowy, a także niektóre certyfikaty międzynarodowe (np. TELC lub ECL na poziomie B1 i wyższym) lub zaświadczenie z polskiej uczelni (o profilu akademickim lub publicznym) o ukończeniu tam kursu języka polskiego jako obcego.",
          p2: "Do uznania za obywatela polskiego wymagany jest wyłącznie Państwowy certyfikat znajomości języka polskiego.",
          warningLabel: "Uwaga:",
          warning1:
            "Dzieci do 16 roku życia (w momencie składania wniosku) nie muszą potwierdzać znajomości języka dla karty rezydenta. Do uznania za obywatela polskiego wymagany jest wyłącznie Państwowy certyfikat znajomości języka polskiego.",
          warning2:
            "Od 1 lipca 2026 roku świadectwa ukończenia szkół policealnych (szkoły policealne) NIE SĄ już przyjmowane jako potwierdzenie znajomości języka ani do karty rezydenta, ani do obywatelstwa.",
        },
      },

      residence: {
        title:
          "NAJCZĘŚCIEJ ZADAWANE PYTANIA (FAQ) – ZEZWOLENIE NA POBYT / KARTA POBYTU",
        q1: {
          q: "1. Czy mogę po prostu przekazać Państwu login i hasło do mojego Profilu Zaufanego, żebyście zrobili wszystko sami?",
          p1: "Nie. Profil Zaufany to Państwa osobisty podpis cyfrowy w Polsce, prawnie równoważny z podpisem własnoręcznym. Przekazywanie dostępu do niego osobom trzecim jest niebezpieczne.",
          p2: "Działamy wyłącznie legalnie: przygotowujemy wszystkie dokumenty wcześniej, a następnie wspólnie z Państwem logujemy się do systemu, wypełniamy i wysyłamy wniosek. Gwarantuje to bezpieczeństwo Państwa danych i 100% poprawność wypełnienia.",
        },
        q2: {
          q: "2. Czy można złożyć wniosek w ostatnim dniu legalnego pobytu?",
          p1: "Technicznie tak, ale jest to ryzykowne. Wniosek elektroniczny musi zostać w pełni wygenerowany i wysłany najpóźniej w ostatnim dniu Państwa obecnego legalnego pobytu w Polsce (niezależnie od tego, czy jest to wiza, dni ruchu bezwizowego, czy okres ważności poprzedniej karty pobytu). Wypełnienie wniosku w systemie wymaga czasu: należy wprowadzić wszystkie dane, wgrać dokumenty i podpisać wniosek.",
          p2: "Aby uniknąć błędów technicznych na stronie rządowej w ostatniej chwili oraz – w razie potrzeby – spokojnie skoordynować działania z pracodawcą w celu wypełnienia jego części formularza, stanowczo zalecamy rozpoczęcie przygotowań do procedury złożenia wniosku co najmniej 1,5–2 miesiące przed upływem ważności Państwa obecnych dokumentów.",
        },
        q3: {
          q: "3. Co należy przygotować wcześniej przed złożeniem wniosku w MOS 2.0?",
          intro:
            "Aby przygotować się do wypełnienia wniosku w systemie MOS 2.0, muszą Państwo posiadać:",
          step1: {
            label: "Dostęp do systemu:",
            text: "Profil Zaufany (login + hasło) – do rejestracji w systemie, logowania i podpisania wniosku.",
          },
          step2: {
            label: "Cyfrowe zdjęcie:",
            text: "Plik ze zdjęciem w formacie JPG musi mieć wymiary co najmniej 684 × 883 pikseli (z zachowaniem proporcji 35 × 45 mm), a jego rozmiar nie może przekraczać 2,5 MB. Zdjęcie musi być wykonane nie wcześniej niż 6 miesięcy przed złożeniem wniosku.",
          },
          step3: {
            label: "E-mail pracodawcy",
            text: "(jeśli składają Państwo wniosek o pobyt ze względu na pracę): Tam zostanie wysłany link do wypełnienia załącznika nr 1.",
          },
          step4: {
            label: "Potwierdzenia opłat:",
            payments: [
              "od 340 zł. do 640 zł. (w zależności od rodzaju zezwolenia)",
              "100 zł. (za wydanie karty)",
              "17 zł. (jeśli ustanawiane jest pełnomocnictwo)",
            ],
          },
          step5: {
            label: "Skany dokumentów",
            text: "(.pdf, .jpg):",
            docs: [
              "paszport (wszystkie strony)",
              "w zależności od sytuacji: umowa / zezwolenie na pracę / ZUS (ZUA / RCA + UPO) / karta pobytu + decyzja / potwierdzenie dochodu / umowa najmu / inne dokumenty dodatkowe.",
            ],
          },
          warningLabel: "Uwaga:",
          warning:
            "Maksymalny rozmiar jednego pliku to 10 MB, a łączna objętość wszystkich załączonych dokumentów we wniosku wynosi do 50 MB.",
        },
        q4: {
          q: "4. Jak mój pracodawca wypełni załącznik nr 1, jeśli nie ma dostępu do mojego konta w MOS 2.0?",
          intro:
            "Pracodawca nie musi przekazywać danych ani logować się na Państwa konto – system MOS w pełni chroni Państwa dane osobowe. Proces wygląda następująco:",
          steps: [
            "Wpisują Państwo e-mail firmy w odpowiednim polu swojego e-wniosku.",
            "Gdy tylko klikną Państwo przycisk „Zapisz i wyślij formularz do pracodawcy”, na podany adres e-mail Państwa firmy natychmiast wysyłana jest oficjalna wiadomość z unikalnym linkiem.",
            "Przedstawiciel firmy przechodzi pod wskazany link, wypełnia dane dotyczące Państwa stanowiska, warunków pracy i wynagrodzenia bezpośrednio na portalu rządowym i podpisuje formularz swoim podpisem elektronicznym (Profilem Zaufanym lub podpisem kwalifikowanym).",
            "Podpisany załącznik nr 1 automatycznie dołącza się do Państwa sprawy elektronicznej. Otrzymają Państwo powiadomienie e-mail, że wniosek jest gotowy do ostatecznego wysłania.",
          ],
          outro:
            "Jeśli Państwa firma lub jej dział HR nie miały jeszcze do czynienia z nową procedurą MOS 2.0 i obawiają się popełnienia błędu, prosimy się nie martwić. W razie potrzeby kontaktujemy się z Państwa firmą, przekazujemy instrukcję krok po kroku i pilnujemy, aby dokument został podpisany poprawnie, co pozwoli na uzyskanie karty na maksymalny okres (do 3 lat).",
        },
        q5: {
          q: "5. Jak złożyć wniosek o kartę pobytu dla dziecka w MOS 2.0?",
          p1: "Główna zasada, która oszczędzi Państwu nerwów: NIE MUSZĄ Państwo tworzyć osobnego konta dla małoletniego dziecka! System jest zaprojektowany tak, że profil dziecka tworzy się wyłącznie w panelu rodzica lub opiekuna prawnego jako profil zależny (subkonto).",
          p2: "Szczegółowa instrukcja znajduje się na naszym profilu na Instagramie.",
        },
        q6: {
          q: "6. Jak długo dziecko może przebywać w Polsce bez ubiegania się o pobyt?",
          p1: "Dziecko urodzone w Polsce, którego rodzice są cudzoziemcami, nie otrzymuje automatycznie zezwolenia na pobyt (czasowy/stały), ale legalność jego początkowego pobytu jest bezpośrednio związana ze statusem rodziców.",
          p2: "Jeśli dziecko urodziło się w okresie, gdy rodzice (lub jedno z nich) posiadają ważną wizę krajową, zezwolenie na pobyt (kartę pobytu) lub inny legalny status, jego pobyt uznaje się za legalny w tym samym okresie, co legalny status rodziców.",
          warningLabel: "Ważne:",
          warning:
            "W celu legalizacji pobytu dziecka należy złożyć OSOBNY wniosek o zezwolenie na pobyt ściśle przed upływem ważności legalnego statusu rodziców (wizy, karty lub ruchu bezwizowego).",
          p3: "Dziecko NIE JEST „dopisane” do karty pobytu rodziców. Aby wykluczyć ryzyko naruszenia przepisów migracyjnych, zalecamy rozpoczęcie procesu legalizacji małoletniego natychmiast po uzyskaniu polskiego aktu urodzenia.",
          p4: "Zezwolenie na pobyt dla dziecka jest udzielane do końca okresu ważności zezwolenia na pobyt rodzica.",
        },
        q7: {
          q: "7. Czy podczas oczekiwania na kartę pobytu można wyjechać do kraju obywatelstwa po wizę?",
          p1: "Oficjalna odpowiedź urzędu: MOŻNA wyjechać. Samo opuszczenie terytorium RP w trakcie toczącego się postępowania nie stanowi podstawy do umorzenia sprawy i nie skutkuje pozostawieniem wniosku bez rozpoznania ani zakończeniem postępowania. Jeśli podczas pobytu w kraju obywatelstwa pomyślnie uzyskają Państwo nową wizę krajową i na jej podstawie wjadą Państwo z powrotem do Polski, nie wpłynie to w żaden sposób na rozpatrzenie Państwa wniosku. Organ nadal ocenia wyłącznie spełnienie przez Państwa standardowych warunków wydania zezwolenia na pobyt zgodnie z Ustawą o cudzoziemcach.",
          p2: "Pomimo że wyjazd po wizę jest legalny, długa nieobecność w Polsce wiąże się z poważnymi zagrożeniami prawnymi i logistycznymi:",
          risks: [
            "Cudzoziemiec ma obowiązek OSOBIŚCIE STAWIĆ SIĘ W URZĘDZIE w celu pobrania odcisków palców W ŚCIŚLE OKREŚLONYM DNIU I GODZINIE, wskazanych w oficjalnym wezwaniu.",
            "Papierowe wezwanie jest wysyłane listem poleconym na polski adres zamieszkania wskazany we wniosku. Jeśli nie ma Państwa w kraju i nikt nie sprawdza Państwa skrzynki pocztowej, po prostu nie dowiedzą się Państwo o wyznaczonym terminie.",
            "Jeśli będą Państwo przebywać za granicą i przegapią wyznaczony dzień pobrania odcisków, Państwa wniosek zostanie automatycznie POZOSTAWIONY BEZ ROZPOZNANIA na podstawie art. 105 ust. 2 Ustawy o cudzoziemcach. Przywrócenie postępowania po tym fakcie jest praktycznie niemożliwe, trzeba będzie składać wniosek na nowo.",
            "Wyjeżdżając po nową wizę, zdają się Państwo całkowicie na decyzję konsulatu w swoim kraju. Nie mamy żadnego wpływu na decyzję konsula dotyczącą wydania wizy ani na przyspieszenie całego procesu. Nie mają Państwo możliwości zminimalizowania tego ryzyka „zdalnie”. Jeśli z jakiegoś powodu otrzymają Państwo ODMOWĘ WYDANIA NOWEJ WIZY KRAJOWEJ (lub proces jej wydawania się przedłuży), stracą Państwo możliwość powrotu do Polski na czas na wyznaczony termin pobrania odcisków palców, co automatycznie zaprzepaści Państwa sprawę o pobyt.",
          ],
        },
        q8: {
          q: "8. Odmowa wydania karty pobytu: kiedy i jak złożyć odwołanie?",
          a: "Jeśli otrzymali Państwo decyzję odmowną i chcą się od niej odwołać, mają Państwo na to 14 dni od dnia doręczenia decyzji. Odwołanie składa się za pośrednictwem organu, który wydał decyzję (on sam przekaże je do organu II instancji). Na kopercie oraz w samym odwołaniu należy wskazać właśnie ten organ. Odwołanie złożone w terminie wstrzymuje wykonanie decyzji, co oznacza, że Państwa pobyt w Polsce pozostaje legalny.",
        },
      },

      citizenship: {
        title: "NAJCZĘŚCIEJ ZADAWANE PYTANIA (FAQ) – OBYWATELSTWO POLSKIE",
        q1: {
          q: "1. Czy przy uzyskiwaniu polskiego paszportu muszę zrzec się swojego dotychczasowego obywatelstwa?",
          p1: "Z punktu widzenia ustawodawstwa Rzeczypospolitej Polskiej – nie, nie ma wymogu zrzeczenia się dotychczasowego obywatelstwa. Obowiązująca Ustawa o obywatelstwie polskim nie zawiera przepisów zobowiązujących cudzoziemca do rezygnacji z obywatelstwa swojego kraju przy uzyskiwaniu statusu obywatela RP.",
          p2: "Państwo wykazuje pełną tolerancję wobec posiadania drugiego paszportu, jednak na terytorium kraju oraz w oficjalnych relacjach z polskimi organami władzy (sądami, urzędami, urzędem skarbowym, strażą graniczną) będą Państwo traktowani wyłącznie jako obywatel Polski. Posiadanie innego obywatelstwa nie może stanowić podstawy do zwolnienia z obowiązków wynikających z polskiego prawa.",
        },
        q2: {
          q: "2. Która ścieżka jest pewniejsza: przez Wojewodę czy przez Prezydenta?",
          a: "Procedura uznania za obywatela przez Wojewodę jest bardziej przewidywalna, ponieważ jest to postępowanie administracyjne: jeśli wnioskodawca spełnia wszystkie warunki określone ustawą i przedłoży pełen komplet dokumentów, prawdopodobieństwo uzyskania pozytywnej decyzji jest wysokie. Wniosek do Prezydenta o nadanie obywatelstwa to ścieżka wyjątkowa dla osób, które nie spełniają któregoś z ustawowych warunków, ale mają ważne powody, by prosić osobiście Prezydenta o nadanie obywatelstwa.",
        },
        q3: {
          q: "3. Czy można złożyć dokumenty do Wojewody, jeśli wciąż czekam na wyniki egzaminu z języka polskiego? ",
          a: "Niestety nie. Dla Wojewody posiadanie państwowego certyfikatu na poziomie B1 (lub dyplomu ukończenia szkoły) to rygorystyczny wymóg w momencie rejestracji sprawy. Złożenie wniosku „awansem” z zamiarem późniejszego doniesienia certyfikatu jest niemożliwe. Urząd po prostu zwróci dokumenty bez rozpatrzenia.",
        },
        q4: {
          q: "4. Czy dziecko urodzone w Polsce automatycznie otrzymuje polskie obywatelstwo?",
          p1: "Nie. Sam fakt urodzenia na terytorium Polski nie daje ani obywatelstwa, ani automatycznego prawa do pobytu (stałego lub czasowego).",
          p2: "Obywatelstwo polskie jest nabywane na zasadzie prawa krwi (łac. – jus sanguinis). Oznacza to, że dziecko nabywa obywatelstwo, jeśli w momencie urodzenia co najmniej jedno z rodziców jest obywatelem Polski. W takim przypadku miejsce urodzenia nie ma znaczenia.",
          p3: "Jeśli żadne z rodziców nie jest obywatelem Polski, obywatelstwo dziecka zależy od obywatelstwa rodziców.",
          p4: "Wyjątek, w którym obowiązuje prawo ziemi (łac. – jus soli) i dziecko otrzymuje polskie obywatelstwo, to bardzo rzadkie przypadki, gdy oboje rodzice są nieznani, nie posiadają żadnego obywatelstwa lub ich obywatelstwo jest nieustalone.",
        },
      },

      transcription: {
        title:
          "NAJCZĘŚCIEJ ZADAWANE PYTANIA (FAQ) – TRANSKRYPCJA ZAGRANICZNYCH AKTÓW STANU CYWILNEGO (Umiejscowienie)",
        q1: {
          q: "1. Czy oryginał mojego zagranicznego aktu pozostaje w polskim USC na zawsze?",
          a: "Tak. W większości przypadków oryginał dokumentu pozostaje w aktach sprawy USC, dlatego przed złożeniem wniosku zaleca się wcześniejsze uzyskanie kolejnego egzemplarza (duplikatu) dokumentu w kraju jego wydania. W wyniku procedury transkrypcji otrzymują Państwo pełnoprawny polski odpowiednik – oficjalny odpis aktu stanu cywilnego.",
        },
        q2: {
          q: "2. Jak trudne jest uzyskanie duplikatu lub odpisu polskiego aktu w przyszłości?",
          intro:
            "Jest to maksymalnie uproszczona procedura, ponieważ wszystkie dane są na stałe wprowadzane do centralnego elektronicznego Rejestru Stanu Cywilnego. Uzyskanie kolejnego dokumentu jest możliwe na dwa sposoby:",
          option1: {
            label: "Osobiście:",
            text: "W absolutnie każdym urzędzie stanu cywilnego (USC) na terenie całej Polski. Nie trzeba jechać do tego konkretnego oddziału, który dokonał pierwszej transkrypcji.",
          },
          option2: {
            label: "Online:",
            text: "Przez portal rządowy gov.pl po zalogowaniu się za pomocą Profilu Zaufanego. Oficjalny cyfrowy odpis z podpisem elektronicznym ministerstwa trafi bezpośrednio na Państwa konto użytkownika w kilka minut.",
          },
        },
        q3: {
          q: "3. Jaki jest okres ważności polskiego dokumentu?",
          p1: "Zgodnie z prawem wydane odpisy aktów stanu cywilnego nie przedawniają się i są ważne bezterminowo.",
          p2: "Jednak w praktyce organy państwowe stosują wewnętrzne regulaminy. Na przykład odpis aktu małżeństwa w dniu składania wniosku o uznanie za obywatela polskiego musi być wydany nie wcześniej niż 3 miesiące przed tą datą. Urząd musi mieć pewność, że w akcie stanu cywilnego nie pojawiły się wzmianki dodatkowe, na przykład o rozwodzie lub zmianie danych osobowych małżonków.",
        },
      },
    },

    contact: {
      header: `Kontakt`,
      //form
      formName: "Imię*",
      formCompany: "Firma",
      formEmail: "Email*",
      formSubject: "Temat*",
      formMessage: "Wiadomość*",
      formMessagePlaceholder: "Wpisz swoją wiadomość tu...",
      formButton: "Wysłać",
      formNameError1: "Proszę podać swoje imię",
      formNameError2: "Imię nie może być krótsze niż 2 litery",
      formNameError3: "Imię musi składać się wyłącznie z liter",
      formEmailError1: "Proszę podać swój adres email",
      formEmailError2: "Proszę podać prawidłowy adres email",
      formSubjectError1: "Proszę podać temat",
      formSubjectError2: "Temat nie może być krótszy niż 2 litery",
      formMessageError1: "Proszę napisać wiadomość",
      formMessageError2: "Wiadomość nie może byc krótsza niż 2 litery",
      //right column
      email: "Adres email",
      phones: "Telefon",
      address: "Adres",
    },

    footer: {
      linksTitle: "Szybkie linki",
      infoTitle: "Informacja",
      contactsTitle: "Kontakty",
    },

    cookies: {
      header: "Polityka Cookies",
      paragraph:
        'Witryna korzysta z plików cookies, dzięki którym może działać lepiej. Stosujemy je dla ułatwienia korzystania z naszych stron, pomiaru, tworzenia statystyk, poprawy funkcjonalności strony. Prosimy o dokonanie stosownych wyborów dotyczących preferencji co do funkcjonowania plików cookies. Klikając "Odrzucam cookies", automatycznie odrzucisz stosowanie wszystkich technologii, poza technicznie niezbędnymi. Klikając "Dostosuj zgody", możesz w dalszym kroku indywidualnie dostosować swoje preferencje co do cookies opcjonalnych. Poprzez kliknięcie "Akceptuję cookies", wyrażasz zgodę na wykorzystywanie technologii cookies zgodnie z ustawieniami Twojej przeglądarki.',
      acceptBtn: "Akceptuję cookies",
      rejectBtn: "Odrzucam cookies (poza niezbędnymi)",
      detailsBtn: "Dostosuj zgody",
      functionalCheckbox: "Akceptuję funkcjonalne cookies",
      analyticalCheckbox: "Akceptuję analityczne cookies",
      marketingCheckbox: "Akceptuję reklamowe cookies",
      saveBtn: "Zapisz zmiany",
    },

    consent: {
      consentLink: "Informacja o przetwarzaniu danych osobowych dostępna ",
      consentLinkText: "TUTAJ",
    },
  },
};
